import { fetchGet } from 'Services/fetchService.js';
import { nodePath } from 'Config/path.js';
import { TResponse } from 'CommonTypes/Tasks/Services/TResponse';

export default async (filter: string) => {
    const result: TResponse = await fetchGet(`${nodePath}/tasks/services/?filter=${filter}`);

    return result;
};
